import React, { FC, useEffect, useState } from 'react'
import { Select, Dropdown, MenuProps } from 'antd';
import Footer from '../_Footer';
import ClientPolicyTable from './_ClientPolicyTable';
import ClientPolicyEditPopup from './createPolicyManually/_ClientPolicyEdit';
import { RootState } from '../app-context/store';
import { useSelector } from 'react-redux';
import { set } from 'lodash';

interface Props {
    customerId: string;
    config: any;
    displayClientDocument: (documentUrl: string | null) => void;
    getPolicies: (filter: any) => void;
    policiesList: any[];
    ridersList: any[];
    policyTypes: any[];
    // displayClientDocument: (documentUrl: string) => void;
    allRowsCounter: number;
    showPopUpTreatment: (type: number) => void;
    customerData: any;
    // onSelectPolicy: (id: string | null) => void;
    // showPopUpTreatment: boolean;
    // openPolicEditPopUp: (val: boolean) => void;
}


const policyTypesObj: any = {
    '0': {
        id: 0,
        name: 'סוג ביטוח',
        description: 'סוג ביטוח'
    },
    '1': {
        id: 1,
        name: 'רכב',
        description: 'רכב'
    },
    '2': {
        id: 2,
        name: 'דירה/עסק',
        description: 'דירה/עסק'
    },
    '3': {
        id: 3,
        name: 'עסק',
        description: 'עסק'
    },
    '4': {
        id: 4,
        name: 'חיים',
        description: 'חיים'
    },
    '5': {
        id: 5,
        name: 'בריאות',
        description: 'בריאות'
    },
    '6': {
        id: 6,
        name: 'אחריות מקצועית',
        description: 'אחריות מקצועית'
    },
    '7': {
        id: 7,
        name: 'ביטוח חבויות',
        description: 'ביטוח חבויות'
    },
    '8': {
        id: 8,
        name: 'ביטוח נסיעות לחו"ל',
        description: 'ביטוח נסיעות לחו"ל'
    },
    '9': {
        id: 9,
        name: 'ביטוח צ.מ.ה',
        description: 'ביטוח צ.מ.ה'
    },
    '10': {
        id: 10,
        name: 'ביטוח תאונות אישיות',
        description: 'ביטוח תאונות אישיות'
    },
    '11': {
        id: 11,
        name: 'חקלאי',
        description: 'חקלאי'
    },
    '12': {
        id: 12,
        name: 'ימי/אווירי',
        description: 'ימי/אווירי'
    },
    '13': {
        id: 13,
        name: 'כתב שרות',
        description: 'כתב שרות'
    },
    '14': {
        id: 14,
        name: 'סחורה בהעברה',
        description: 'סחורה בהעברה'
    },
    '15': {
        id: 15,
        name: 'עובדים זרים',
        description: 'עובדים זרים'
    },
    '16': {
        id: 16,
        name: 'קבלנים',
        description: 'קבלנים'
    },
    '17': {
        id: 17,
        name: 'שוק ההון',
        description: 'שוק ההון'
    },
    // '18': {
    //     id: 18,
    //     name: 'שוק ההון',
    //     description: 'שוק ההון'
    // },
    '19': {
        id: 19,
        name: 'הלוואה חברתית',
        description: 'הלוואה חברתית'
    },
    '20': {
        id: 20,
        name: 'שירותי דרך',
        description: 'שירותי דרך'
    },
    '21': {
        id: 21,
        name: 'חיות',
        description: 'חיות'
    },
    '22': {
        id: 22,
        name: 'עמדת טעינה',
        description: 'עמדת טעינה'
    }
}



const PoliciesClientDetails: FC<Props> = (props: Props) => {
    const newPolicyWithAdditionNumber = useSelector((state: RootState) => state.clientsSlice.newPolicyWithAdditionNumber);

 //  Policy Filter 
    const [policySeachText, setPolicySearchText] = useState<string>('');
    const [policyTimeoutId, setPolicyTimeoutId] = useState<number | any | null>(undefined);
    const [policyTypes, setPolicyTypes] = useState<any[]>([]);
    const [policyFilter, setPolicyFilter] = useState<any>({
        page: 1,
        customerId: props.customerId,
        searchTerm: '',
        from: undefined,
        to: undefined,
        policyType: undefined,
    });
    const [policiesPagerConf, setPoliciesPagerConf] = useState<any>({
        pageSize: 50,
        currentPage: 1,
        totalItems: 0
    });
    const [policyTypeFilter, setPolicyTypeFilter] = useState<string>('-2');

    // policies
    const [showPolicyEditPopUp, setShowPolcyEditPopup] = useState<boolean>(false);
    const [policyEditType, setPolicyEditType] = useState<string>('')
    const [addPoliciesOptions, setAddPoliciesOptions] = useState<MenuProps['items']>([]);


    const [treatmentsTimeoutId, setTreatmentsTimeoutId] = useState<number | any | null>(undefined);
    

    useEffect(() => {
        init();
    }, [])


    const init = () => {
        const policyTypesOptions: MenuProps['items'] = [];
        const policyKeys = Object.keys(policyTypesObj);
        policyKeys.forEach((key: string) => {
            const policyType = policyTypesObj[key];
            if (policyType.id != 0) {
                policyTypesOptions.push({
                    key: policyType.id,
                    label: (
                        <li className="pointer rtl"
                            onClick={() => { openPolicEditPopUp(true, policyType.id) }}
                        >

                            {policyType.name}
                        </li>
                    ),
                })
            }
        })
        setAddPoliciesOptions(policyTypesOptions);
    }



    const nextPage = (page: number) => {
        const filter = {
            page: page,
            customerId: props.customerId
        }
        setPolicyFilter(filter);
        props.getPolicies(filter);
    }

    // const nextPage = (page: number) => {

    //     const newFilter = policiesPagerConf
    //     newFilter.currentPage = page;
    //     const filter = {
    //         page: page,
    //         customerId: props.customerId
    //     }
    //     setPolicyFilter(filter);
    //     props.getPolicies(filter);
    // }

    const onFirstPageClick = (page: number) => {
        const filter = {
            page: 1,
            customerId: props.customerId
        }
        setPolicyFilter(filter);
        props.getPolicies(filter);
    }


    // const onLastPageClick = (page: number) => {
    //     const filter = {
    //         page: page,
    //         customerId: props.customerId
    //     }
    //     setPolicyFilter(filter);
    //     getPolicies(filter);
    // }


    // policy functions
    const clearPolicyFilter = () => {
        setPolicySearchText('');
        const filter = {
            page: 1,
            customerId: props.customerId,
        }
        setPolicyFilter(filter);
        props.getPolicies(filter);
    }

    const handlePolicySearchChange = async (event: any) => {
        const newSearchText = event.target.value;
        setPolicySearchText(newSearchText.trim());
        const newFilter = policyFilter;
        newFilter.searchTerm = newSearchText.trim();
        setPolicyFilter(newFilter);

        clearTimeout(treatmentsTimeoutId);
        const newTimeoutId = setTimeout(() => {
            props.getPolicies(newFilter);
        }, 1000);
        setPolicyTimeoutId(newTimeoutId);
    };

    const handlePolicyTypeChange = (value: string, option: { label: string; value: string; }) => {
        // console.log('handlePolicyTypeChange option', option)
        const newFilter = policyFilter;
        console.log('handlePolicyTypeChange', value)
        newFilter.policyType = undefined;

        let end: Date | null = new Date();
        if (value == '-1') {
            console.log('option.value', option.value)
            newFilter.from = end;
        } else if (value == '-2') {
            newFilter.from = undefined;
        } else if (value == '5') {
            newFilter.policyType = "riders";
            newFilter.notYetActive = false;
        } 
        else if (value == '6') {
            newFilter.policyType = undefined;
             newFilter.notYetActive = true;
        } 
        else if (value == '1') {
            newFilter.policyType = "elementary";
            newFilter.notYetActive = false;
        }
        // if (value !== '-1') {
        //     newFilter.policyType = value;
        // } else {
        //     newFilter.policyType = undefined
        // }
        console.log('newFilter', newFilter)
        setPolicyTypeFilter(value)
        // setDocumentsFilter(newFilter);
        const newTimeoutId = setTimeout(() => {
            props.getPolicies(newFilter);
        }, 1000);
    }

    const onSelectPolicy = (id: string | null) => {
        // setSelectedPolicy(id);
        // setShowPolicyContent(id !==null);
    }

    // Policy Edit popup
    const openPolicEditPopUp = (show?: boolean, type?: string) => {
        console.log('openPolicEditPopUp', show, type)
        if (!show) {
            show = false
        }
        if (type) {
            setPolicyEditType(type);
        }
        setShowPolcyEditPopup(show);
    }

    const getPoliciesList = () => {
        // policies is list of arrays of policies, return flat list of policies
        const policies: any[] = [];
        props.policiesList.forEach((policy: any) => {
            policy.map((p: any) => {
                policies.push(p);
            });
        });
        return policies;
    }

    useEffect(() => {
        if(newPolicyWithAdditionNumber.policyId && newPolicyWithAdditionNumber.policyId.length > 0
            && newPolicyWithAdditionNumber.additionNumber && newPolicyWithAdditionNumber.additionNumber.length > 0
        ) {
            openPolicEditPopUp(true, '1');
        }
      
    }, [newPolicyWithAdditionNumber])
    

    const emptyFunc = () => { }

    return (
        <>
            {
                showPolicyEditPopUp &&
                <ClientPolicyEditPopup
                    messageTitle={'עריכת/הוספה פוליסה'}
                    ShowHidePopup={openPolicEditPopUp}
                    ClosePopup={() => openPolicEditPopUp(false)}
                    type={policyEditType}
                    customerId={props.customerId}
                    customerData={props.customerData}
                    policyTypesObj={policyTypesObj}
                    policiesList={getPoliciesList()}
                />
            }
            <div className="content-body">
                <div className='flex-space-between'>
                    <div className="filter-row flex-centered client-search">
                        <div className="filter-input search long-text">
                            <input type="text" value={policySeachText} placeholder="חיפוש" onChange={handlePolicySearchChange} />
                            <div className="icon search"></div>
                        </div>
                        <div className="filter-input select policy-type-select">
                            <Select
                                style={{ width: '100%' }}
                                placeholder="כל הסוכנים"
                                value={policyTypeFilter}
                                onChange={(value: string, option: any) => handlePolicyTypeChange(value, option)}
                                options={
                                    [
                                        {
                                            label: 'הכל',
                                            value: '-2'
                                        },
                                        {
                                            label: 'כל הפוליסות בתוקף',
                                            value: '-1'
                                        },
                                        {
                                            label: 'ביטוח אלמנטרי',
                                            value: '1'
                                        },

                                        {
                                            label: 'שירותי דרך',
                                            value: '5'
                                        },
                                        {
                                            label: 'עוד לא פעיל',
                                            value: '6'
                                        }
                                    ]
                                }
                            />

                        </div>
                        <div className="filter-input select policy-type-select">
                            <Select
                                style={{ width: '100%' }}
                                placeholder="חיפוש קבוצה"
                                value={'-1'}
                                onChange={() => { }}
                                options={
                                    [
                                        {
                                            label: 'הצג הכל',
                                            value: '-1'
                                        },
                                        {
                                            label: 'הלקוח',
                                            value: '1'
                                        }
                                    ]
                                }
                            />
                        </div>

                        <div className="filter-button">
                            <div className="icon refresh-counter pointer" onClick={clearPolicyFilter}></div>
                        </div>
                    </div>
                    {/* <div className='flex-centered'>
                        <Dropdown menu={{ items: addPoliciesOptions }}>
                            <button type="button" className="button blue has-icon flex-centered flex-justify-center">
                                <div className="icon add"></div>
                                הוסף פוליסה
                            </button>
                        </Dropdown>
                        <div className="icon gear"></div>
                    </div> */}

                </div>
                <div className='content-body-inner'>

                    <ClientPolicyTable data={{
                        items: props.policiesList,
                        riders: props.ridersList
                    }} config={{
                        displayFile: props.displayClientDocument
                    }} actions={{
                        onSelectPolicy: (id: string | null) => onSelectPolicy(id),
                        showPolicyEdit: (val: boolean) => openPolicEditPopUp(val),
                        onClaimCreate: (id: string | null, data?: any) => props.config.onClaimCreate ? props.config.onClaimCreate(id, data) : emptyFunc(),
                        showMessagePopup: (message: string) => props.config.showMessagePopup ? props.config.showMessagePopup(message) : emptyFunc()
                    }}
                        showAddTreatmentPopup={props.showPopUpTreatment}
                        customerData={props.customerData}
                    />

                </div>

            </div>

            <Footer allRowsDataNumber={props.allRowsCounter} AllRowsCounter={props.allRowsCounter ? Math.ceil(props.allRowsCounter / 50) : 0} rowsInPage={50} currentPage={policyFilter.page ? policyFilter.page : 1}
                onFirstPageClick={(number: number) => onFirstPageClick(number)}
                onLastPageClick={(number: number) => nextPage(number)}
                onNextPageClick={(number: number) => nextPage(number)}
                onPrevPageClick={(number: number) => nextPage(number)}
            /></>
    )
}

export default PoliciesClientDetails